import Link from 'next/link'
import Image from 'next/image'

import Layout from 'components/layout'
import { ProductCardCategorie } from 'components/shop/productCard'

export default function displayGrid({ collection }) {
  return (
    <Layout>
      <div className="grid gap-4 md:grid-cols-3">
        {collection.products.edges.map(({ node: thisProduct }) => (
          <ProductCardCategorie
            key={thisProduct.id}
            name={thisProduct.title}
            imageData={thisProduct.featuredImage}
            href={`/shop/product/${thisProduct.handle}`}
            collectionName={collection.title}
          />
        ))}
      </div>
    </Layout>
  )
}
